module.exports = __webpack_public_path__ + "img/log-long.74d15991.webp";